import React from 'react';
import styles from './KeyInvestors.module.scss';
import { organisationIcon } from '../../../../../../assets/hostedassets';
import A4Page from '../../../../../AicaPDFReport/A4Page/A4Page';
import { reportSectionsToShow } from '../../../../../AicaPDFReport/AicaPDFReport';
import { REPORT_SECTION_NAMES } from '../../../../../../store/pdfReport/pdfReport_constants';
import clsx from 'clsx';
import HeaderBodyBox from '../../../../../../common/HeaderBodyBox/HeaderBodyBox';

interface KeyInvestorsProps {
    fundingInfo: any;
    isPDFReport?: boolean;
}

const KeyInvestors: React.FC<KeyInvestorsProps> = ({ fundingInfo, isPDFReport = false }) => {
    if (!fundingInfo?.investors?.length) {
        return <></>;
    }

    const investorsContent = (
        <div className={styles.Container}>
            {fundingInfo?.investors?.map((investor, i) => (
                <div className={styles.Investor} key={i}>
                    <div className={styles.Image}>
                        <img
                            src={investor?.imageLink || organisationIcon}
                            alt="profile"
                            width="100%"
                            onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = organisationIcon;
                            }}
                        />
                    </div>
                    <div className={styles.Name} title={investor?.name}>
                        {investor?.name?.length > 60 ? `${investor?.name?.substring?.(0, 60)}...` : investor?.name}
                    </div>
                </div>
            ))}
        </div>
    );

    const render = (
        <HeaderBodyBox
            title="Key Investors"
            className={clsx(styles.KeyInvestors, {
                [styles.KeyInvestorsPDFReport]: isPDFReport,
            })}
            isPDFReport={isPDFReport}
        >
            {investorsContent}
        </HeaderBodyBox>
    );

    if (isPDFReport)
        return fundingInfo?.investors?.length && reportSectionsToShow?.includes(REPORT_SECTION_NAMES.KEY_INVESTORS) ? (
            <A4Page sectionName={REPORT_SECTION_NAMES.KEY_INVESTORS}>{render}</A4Page>
        ) : (
            <></>
        );
    else return render;
};

export default KeyInvestors;
